import React from 'react';
import MarkdownPage from './MarkdownPage';

export default function ResearchConsent() {
  return <MarkdownPage file="research-consent.md" />;
}
